import React from 'react';
import { observer } from 'mobx-react';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import {
  Avatar, Box, IconButton, Typography,
} from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import Color from 'color';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';

const Header: React.FC = () => {
  const isHomePage = React.useMemo(() => UiStore.currentPage === Pages.home, [UiStore.currentPage]);

  return (
    <Box bgcolor="primary.main" py={2.5} px={1} position="relative">
      {isHomePage ? (
        <IconButton sx={{ position: 'absolute', right: 10, top: 10 }} onClick={() => UiStore.close()}>
          <CloseIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
        </IconButton>
      ) : (
        <IconButton
          sx={{
            position: 'absolute', right: 10, top: 10, fontSize: 16,
          }}
          onClick={() => UiStore.setPage(Pages.home)}
        >
          <ArrowBackIcon sx={{ color: 'text.secondary' }} />
        </IconButton>
      )}
      <Box display="flex" alignItems="center" gap={1}>
        <Avatar sx={{
          bgcolor: (th) => Color(th.palette.primary.main).lighten(0.2).hex(),
          width: 48,
          height: 48,
          fontSize: 18,
          fontWeight: 600,
          color: 'text.secondary',
        }}
        >
          {UserStore.user?.firstName?.[0]}
        </Avatar>
        <Box>
          <Typography textTransform="capitalize" color="text.secondary" fontSize={16}>
            <Trans
              i18nKey="hello"
              defaults="Hello"
            />
            {' '}
            {UserStore.user?.firstName ?? ''}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default observer(Header);
